import { Module } from 'vuex';
import { RootState } from '../types';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { FirmwareState } from './types';

export const state: FirmwareState = {
  firmware: undefined,
};

const namespaced: boolean = true;

export const firmware: Module<FirmwareState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
